import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WallpaperIcon from "@mui/icons-material/Wallpaper";

import toast from "react-hot-toast";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { moodboardSortOptions } from "utils/data";
import { compare } from "utils/helper";
import defaultStyleImage from "assets/images/upstyled/default_background.png";
import EmptyMoodboardRecord from "../../moodboards/components/EmptyMoodboardRecord";
import CollectionBackgroundEditModal from "pages/de/collection/detail/components/CollectionBackgroundEditModal";
import AddMoodboardModal from "pages/de/collection/components/AddMoodboardModal";

import Prompt from "components/UpStyled/Prompt";

//This is for moodboard and collection one to one relationship
const ManageMoodboardModal2 = ({
  visible,
  handleClose,
  handleOk,
  collection,
  handleRefresh = () => {},
  canWrite,
  sharedView,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const moodboard = collection?.moodboard?.[0] || {};

  const handleDelete = async () => {
    if (!moodboard.id) {
      return toast.error(`Ccan't find the moodboard!`);
    }

    const { data } = await api.moodboard.updateCollectionRelation(moodboard.id, {
      collection_id: null,
    });

    toast.success(`Remove moodboard successfully!`);

    handleRefresh();
  };

  return (
    <Dialog
      open={visible}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
    >
      <DialogTitle id="alert-dialog-title">
        {moodboard.name}
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <SuiBox sx={{ minWidth: 300 }}>
          <div>
            <div style={{ padding: "4px" }}>
              {moodboard?.img?.url ? (
                <SuiBox
                  sx={{
                    position: "relative",
                    height: "calc(100% - 85px)",
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <img
                    style={{ maxHeight: 700, height: "calc(100% - 85px)", width: "100%" }}
                    alt={moodboard?.img?.name}
                    src={moodboard?.img?.url || defaultStyleImage}
                  />

                  {isHovered && canWrite ? (
                    <SuiBox
                      display="flex"
                      gap={1}
                      alignItems="center"
                      sx={{
                        position: "absolute",
                        left: "calc(50% - 85px)",
                        bottom: 20,
                      }}
                    >
                      <SuiButton
                        variant="contained"
                        color={"white"}
                        onClick={() =>
                          sharedView
                            ? navigate(`/shared-with-me/moodboards?id=${moodboard.id}`)
                            : navigate(`/workspace/moodboard?id=${moodboard.id}`)
                        }
                      >
                        EDIT
                      </SuiButton>
                      {sharedView ? null : (
                        <SuiButton variant="contained" color={"error"} onClick={handleDelete}>
                          Remove
                        </SuiButton>
                      )}
                    </SuiBox>
                  ) : null}
                </SuiBox>
              ) : (
                <EmptyMoodboardRecord
                  refresh={() => {
                    handleRefresh();
                  }}
                  content={
                    sharedView ? (
                      <SuiBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ height: "100%", width: "100%" }}
                      >
                        {" "}
                        No available moodboard
                      </SuiBox>
                    ) : null
                  }
                  collection={collection}
                  selectedMoodboards={[]}
                  sx={{ width: "100%", height: 200, textAlign: "center" }}
                />
              )}
            </div>
          </div>
        </SuiBox>
      </DialogContent>
    </Dialog>
  );
};

export default ManageMoodboardModal2;
